<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <div style="display: inline;">
      <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/custom/ruike/wo/feeding/record/page" ref="yt" getKey="rows" :columns="columns" @afterGet="afterGet" @selectionChange="selectionChange">
        <template #conditions>
          <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
            <el-form-item :label="$t('shebeimingcheng')">
              <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList"></yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('jianyitouliaowuliaomingcheng')">
              <el-input v-model="yt.conditions.simpleFeedingMaterialName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('touliaoshijian')">
              <yi_time_input :format="'yyyy-MM-dd HH:mm:ss'" :maxTime="31 * 24 * 3600 * 1000" type="datetimerange" ref="yiTime" :start.sync="yt.conditions.begin" :end.sync="yt.conditions.end"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('yuancailiaozhonglei')">
              <yi_dictionary_select :max="1" :type="'CUSTOMER_RAW_MATERIAL_TYPE'" :ids.sync="yt.conditions.rawMaterialType"> </yi_dictionary_select>
            </el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain size="mini">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="clear()" size="mini">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form>
        </template>

        <template #buttonsR>
          <el-button :loading="weight_info_export_loading" size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
          <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
        </template>

        <template #tlsl="{row}">
          {{ row.feedingWeight }}
        </template>
      </yi_curd_table>

      <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" dialog-scroller>
        <template v-if="yt.editObj.action === 'hunliaoBOM'">
          <div class="dialog-scroller">
            <el-row>
              <span style="font-size: 20; color: grey;"> {{ $t('hunliaogongdanhao') }}:{{ yt.editObj.mixOrder.no }}</span>
            </el-row>
            <mixtureBom :tagId="yt.editObj.id"></mixtureBom>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
const date = new Date();
const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();
const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
import XLSX from 'xlsx';

export default {
  name: 'web_production_management_simple_wo_feed_record',
  data() {
    return {
      weight_info_export_loading: false,
      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'touliaoshijian',
          prop: 'feedingTime',
          type: 'time'
        },
        {
          label: 'touliaoren',
          prop: 'feedingUser.nickname'
        },
        {
          label: 'jianyitouliaowuliaobianma',
          prop: 'simpleFeedingMaterialCode'
        },
        {
          label: 'jianyitouliaowuliaomingcheng',
          prop: 'simpleFeedingMaterialName'
        },
        {
          label: 'dangcishuikouyuntoubili',
          prop: 'currentSprueAllowanceRatio'
        },
        {
          label: 'yuancailiaozhonglei',
          type: 'dictionary',
          prop: 'rawMaterialType',
          key: 'CUSTOMER_RAW_MATERIAL_TYPE'
        },
        {
          label: 'yuanliaotouruliang',
          prop: 'rawMaterialInput'
        },
        {
          label: 'shuikoutouruliang',
          prop: 'sprueInput'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        begin: begin,
        end: end,
        feedingDateBegin: begin,
        feedingDateEnd: end
      };
      this.yt.get(1);
      this.$nextTick(() => {
        this.utils.event_hub.$emit('RESIZE');
      });
    }, 300);
  },
  methods: {
    clear() {
      this.yt.conditions = {};
      this.yt.conditions.begin = begin;
      this.yt.conditions.end = end;
      this.yt.conditions.feedingDateBegin = begin;
      this.yt.conditions.feedingDateEnd = end;
      this.yt.get(1);
    },
    exportExcel() {
      this.weight_info_export_loading = true;
      //查询表格
      this.http
        .get('/custom/ruike/wo/feeding/record/page?pageNum=1&pageSize=9999', { params: { ...this.yt.conditions } })
        .then(res => {
          let tableFirst = this.columns.map(i => this.$t(i.label));
          let tableData = [];
          tableData.push(tableFirst);
          let listData = res.data.rows;
          for (let i = 0; i < listData.length; i++) {
            let dataArr = this.getTableDataArr(listData[i], tableFirst);
            tableData.push(dataArr);
          }
          const worksheet = XLSX.utils.aoa_to_sheet(tableData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, `投料记录_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
        })
        .finally(() => {
          this.weight_info_export_loading = false;
        });
    },
    getTableDataArr(row, tableFirst) {
      let dataArr = [];
      dataArr[tableFirst.indexOf(this.$t('shebeimingcheng'))] = row.equipment.name;
      dataArr[tableFirst.indexOf(this.$t('touliaoshijian'))] = row.feedingTime && this.dayjs(row.feedingTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[tableFirst.indexOf(this.$t('touliaoren'))] = row.feedingUser ? row.feedingUser.nickname : '';
      dataArr[tableFirst.indexOf(this.$t('jianyitouliaowuliaobianma'))] = row.simpleFeedingMaterialCode;
      dataArr[tableFirst.indexOf(this.$t('jianyitouliaowuliaomingcheng'))] = row.simpleFeedingMaterialName;
      dataArr[tableFirst.indexOf(this.$t('dangcishuikouyuntoubili'))] = row.currentSprueAllowanceRatio;
      dataArr[tableFirst.indexOf(this.$t('yuancailiaozhonglei'))] = row.rawMaterialType ? this.$t(this.store.state.dictJson['CUSTOMER_RAW_MATERIAL_TYPE'][row.rawMaterialType]) : '';
      dataArr[tableFirst.indexOf(this.$t('yuanliaotouruliang'))] = row.rawMaterialInput;
      dataArr[tableFirst.indexOf(this.$t('shuikoutouruliang'))] = row.sprueInput;
      return dataArr;
    }
  }
};
</script>
